import React from 'react';
import 'shared/components/navbar/navbar-logo.scss';
import Navbar from 'src/components/Navbar';
import useFeatureFlags from 'src/hooks/useFeatureFlags';
import {CTAButtonProps} from '../../../components/Navbar/NavbarCTAButton';
import NewPublicNavbar from '../new-public-navbar';

const menuItems = [
  {path: '/colleges/search', title: 'College Search', routed: true},
  {path: '/how-it-works', title: 'How it Works', routed: false},
  {
    title: 'Students',
    menuItems: [
      {title: 'High School Students', path: '/about', routed: false},
      {title: 'Community College Students', path: '/transfer', routed: false},
      {title: 'Parents', path: '/parents', routed: false},
    ],
  },
  {
    title: 'Educators',
    menuItems: [
      {title: 'Counselors & Teachers', path: '/educators', routed: false},
      {title: 'Educator Resources', path: '/blog/educators-resources/', routed: false},
    ],
  },
  {
    title: 'Resources',
    menuItems: [
      {title: 'Help Center', path: 'https://help.raise.me', routed: false},
      {title: 'Student Blog', path: '/blog/', routed: false},
      {title: 'About Us', path: 'https://campuslogic.com/company/', routed: false},
    ],
  },
];

const PublicNavbar = () => {
  const flags = useFeatureFlags(['newHomePage']);

  if (Object.keys(flags).length === 0) {
    return null;
  }

  if (flags.newHomePage) {
    return <NewPublicNavbar />;
  }

  const ctaButtons: CTAButtonProps[] = [
    {
      path: `/login?next=${location.pathname}`,
      title: 'Log In',
      ariaLabel: 'Invite (opens a dialog)',
      routed: true,
      outline: true,
    },
    {
      path: `/signup?next=${location.pathname}`,
      title: 'Sign Up',
      ariaLabel: 'Invite (opens a dialog)',
      routed: true,
    },
  ];

  return <Navbar menus={menuItems} ctaButtons={ctaButtons} routed={false} />;
};

export default PublicNavbar;
